import { Component } from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";
import {ButtonComponent} from "../../../shared/components/button/button.component";
import {
  ImageTextCardWrapperComponent
} from "../../../shared/components/image-text-card-wrapper/image-text-card-wrapper.component";

@Component({
  selector: 'app-home-team-cards',
  imports: [
    TranslatePipe,
    ButtonComponent,
    ImageTextCardWrapperComponent
  ],
  templateUrl: './home-team-cards.component.html',
  styleUrl: './home-team-cards.component.scss'
})
export class HomeTeamCardsComponent {
  services = [
    {
      icon: 'assets/images/home-page/healthcare.png',
      title: 'home-page.sectors-title-healthcare',
      description: 'home-page.sectors-description-healthcare',
    },
    {
      icon: 'assets/images/sector/public-sector.png',
      title: 'home-page.services-title-public-sector',
      description: 'home-page.services-description-public-sector',
    },
    {
      icon: 'assets/images/services/financial-services.png',
      title: 'home-page.services-title-financial-services',
      description: 'home-page.services-description-financial-services',
    },
    {
      icon: 'assets/svgs/handshake.svg',
      title: 'home-page.sectors-title-hospitality',
      description: 'home-page.sectors-description-hospitality',
    },
    {
      icon: 'assets/images/home-page/automobile.png',
      title: 'home-page.sectors-title-automobile',
      description: 'home-page.sectors-description-automobile',
    },
  ];
}
